var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAccountPortfolio = function SvgIcAccountPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_account_portfolio_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.021 4.969V2.106a4.627 4.627 0 0 1 2.863 2.863H7.02Zm4.576.834a6.114 6.114 0 0 0-5.41-5.41c-.366-.04-.666.262-.666.63v4.779c0 .368.298.667.667.667h4.778c.368 0 .67-.3.631-.666ZM4.729 2.617a.75.75 0 0 0-.325-1.465 5.39 5.39 0 0 0 1.17 10.65 5.389 5.389 0 0 0 5.264-4.241.75.75 0 0 0-1.466-.318 3.888 3.888 0 0 1-7.685-.83A3.89 3.89 0 0 1 4.73 2.618Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_account_portfolio_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgIcAccountPortfolio;